export default "__VITE_ASSET__CLL5ho3w__"